import { render, staticRenderFns } from "./settings-company-general.vue?vue&type=template&id=9c9d00f6&"
import script from "./settings-company-general.ts?vue&type=script&lang=ts&"
export * from "./settings-company-general.ts?vue&type=script&lang=ts&"
import style0 from "./settings-company-general.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports